/* eslint-disable import/prefer-default-export */
export const optionsTada = [
    {
        aclCode: 'oms_lite_header_tada',
        key: 'tada',
        label: 'TADA',
        children: [
            {
                aclCode: 'oms_lite_tada_category',
                key: 'tadacategory',
                label: 'Category',
                url: '/tada/tadacategory',
            },
            {
                aclCode: 'oms_lite_tada_config',
                key: 'configuration',
                label: 'Configuration',
                url: '/tada/configuration',
            },
            {
                aclCode: 'oms_lite_tada_shipping_company',
                key: 'shippingcompany',
                label: 'Shipping Company',
                url: '/tada/shippingcompany',
            },
        ],
    },
];
